import dayjs from 'dayjs';
import { groupBy, sort } from 'ramda';

import { VersionHistoryFileFieldsFragment } from '../../graphql/generated';

export const groupVersionsByCreatedAt = (
  versions: VersionHistoryFileFieldsFragment[]
): Record<string, VersionHistoryFileFieldsFragment[]> => {
  const createdAt = (x: VersionHistoryFileFieldsFragment) =>
    dayjs(x.createdAt).utc().format('YYYY-MM-DD');

  return groupBy(createdAt, versions);
};

export const sortVersionsByLatest = (
  versions: VersionHistoryFileFieldsFragment[]
): VersionHistoryFileFieldsFragment[] =>
  sort(
    (a, b) => dayjs(b.createdAt).unix() - dayjs(a.createdAt).unix(),
    versions
  );

export const formatVersionGroupDate = (date: string): string => {
  const versionGroupDate = dayjs(date).utc();

  if (versionGroupDate.isToday()) {
    return 'Today';
  }

  if (versionGroupDate.isYesterday()) {
    return 'Yesterday';
  }

  return versionGroupDate.format('MMMM DD, YYYY');
};
